/* tslint:disable */
/* eslint-disable */
/**
 * Goat Parser API
 * API документация для Goat Parser
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GoatGetBuyBarData200ResponseInner } from '../models';
// @ts-ignore
import type { GoatGetProductTemplate200Response } from '../models';
// @ts-ignore
import type { GoatSearchProducts200Response } from '../models';
// @ts-ignore
import type { GoatSearchProductsRequest } from '../models';
/**
 * GoatApi - axios parameter creator
 * @export
 */
export const GoatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Получить buy bar data для вариантов продукта
         * @param {string} productTemplateId ID шаблона продукта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        goatGetBuyBarData: async (productTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTemplateId' is not null or undefined
            assertParamExists('goatGetBuyBarData', 'productTemplateId', productTemplateId)
            const localVarPath = `/api/products/buy-bar-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (productTemplateId !== undefined) {
                localVarQueryParameter['productTemplateId'] = productTemplateId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить шаблон продукта по slug
         * @param {string} slug Slug продукта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        goatGetProductTemplate: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('goatGetProductTemplate', 'slug', slug)
            const localVarPath = `/api/products/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Поиск продуктов
         * @param {GoatSearchProductsRequest} goatSearchProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        goatSearchProducts: async (goatSearchProductsRequest: GoatSearchProductsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goatSearchProductsRequest' is not null or undefined
            assertParamExists('goatSearchProducts', 'goatSearchProductsRequest', goatSearchProductsRequest)
            const localVarPath = `/api/products/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(goatSearchProductsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoatApi - functional programming interface
 * @export
 */
export const GoatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoatApiAxiosParamCreator(configuration)
    return {
        /**
         * Получить buy bar data для вариантов продукта
         * @param {string} productTemplateId ID шаблона продукта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async goatGetBuyBarData(productTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GoatGetBuyBarData200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.goatGetBuyBarData(productTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoatApi.goatGetBuyBarData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить шаблон продукта по slug
         * @param {string} slug Slug продукта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async goatGetProductTemplate(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoatGetProductTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.goatGetProductTemplate(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoatApi.goatGetProductTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Поиск продуктов
         * @param {GoatSearchProductsRequest} goatSearchProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async goatSearchProducts(goatSearchProductsRequest: GoatSearchProductsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GoatSearchProducts200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.goatSearchProducts(goatSearchProductsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoatApi.goatSearchProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoatApi - factory interface
 * @export
 */
export const GoatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoatApiFp(configuration)
    return {
        /**
         * Получить buy bar data для вариантов продукта
         * @param {string} productTemplateId ID шаблона продукта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        goatGetBuyBarData(productTemplateId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GoatGetBuyBarData200ResponseInner>> {
            return localVarFp.goatGetBuyBarData(productTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить шаблон продукта по slug
         * @param {string} slug Slug продукта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        goatGetProductTemplate(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<GoatGetProductTemplate200Response> {
            return localVarFp.goatGetProductTemplate(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Поиск продуктов
         * @param {GoatSearchProductsRequest} goatSearchProductsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        goatSearchProducts(goatSearchProductsRequest: GoatSearchProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GoatSearchProducts200Response> {
            return localVarFp.goatSearchProducts(goatSearchProductsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoatApi - object-oriented interface
 * @export
 * @class GoatApi
 * @extends {BaseAPI}
 */
export class GoatApi extends BaseAPI {
    /**
     * Получить buy bar data для вариантов продукта
     * @param {string} productTemplateId ID шаблона продукта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoatApi
     */
    public goatGetBuyBarData(productTemplateId: string, options?: RawAxiosRequestConfig) {
        return GoatApiFp(this.configuration).goatGetBuyBarData(productTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить шаблон продукта по slug
     * @param {string} slug Slug продукта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoatApi
     */
    public goatGetProductTemplate(slug: string, options?: RawAxiosRequestConfig) {
        return GoatApiFp(this.configuration).goatGetProductTemplate(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Поиск продуктов
     * @param {GoatSearchProductsRequest} goatSearchProductsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoatApi
     */
    public goatSearchProducts(goatSearchProductsRequest: GoatSearchProductsRequest, options?: RawAxiosRequestConfig) {
        return GoatApiFp(this.configuration).goatSearchProducts(goatSearchProductsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

